import React from 'react';
import { OpenFormIconButton } from 'features/nekst-widgets';
import {
  ProjectRole,
  ProjectRolePermission,
  UpdateProjectRoleRequest,
  useProjectRolesService
} from 'nekst-api';
import { AfterSubmitFunc, FormTemplate, TextInput, useShowContextRequired } from 'ui-builder';

function UpdateRoleForm(
  props: {
    role: ProjectRole,
    afterSubmitFunc?: AfterSubmitFunc,
  },
) {
  const projectRolesService = useProjectRolesService();

  return (
    <FormTemplate<UpdateProjectRoleRequest, ProjectRole>
      title={`Update role - ${props.role.name}`}
      initialData={{
        name: props.role.name,
      }}
      submitFormFunc={(request) => projectRolesService.updateRole(
        props.role.id,
        request,
      )}
      validationSchema={{
        name: {
          type: 'string',
          constraints: {
            required: true,
            maxLength: 45,
            minLength: 3,
          },
        },
      }}
      afterSubmitFunc={props.afterSubmitFunc}
    >
      <TextInput source="name" />
    </FormTemplate>
  );
}

export default function UpdateRoleButton() {
  const showContext = useShowContextRequired<ProjectRole>();

  const data = showContext.data;

  if (data._permissions.includes(ProjectRolePermission.UPDATE)) {
    return (
      <OpenFormIconButton
        form={<UpdateRoleForm role={data} />}
        title="Update Role"
      />
    );
  } else {
    return null;
  }
}
